import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'
import PurchaseOrder from '~/_shared/models/PurchaseOrder'

// state
export const state = {
  list: [],
  purchaseOrder: new PurchaseOrder(),
  total: 0,
  pdf: undefined
}

// getters
export const getters = {
  list: state => state.list,
  total: state => state.total,
  purchaseOrder: state => state.purchaseOrder,
  pdf: state => state.pdf
}

// mutations
export const mutations = {
  LIST (state, data) {
    state.list = data
  },
  TOTAL (state, data) {
    state.total = data
  },
  PURCHASE_ORDER (state, data) {
    state.purchaseOrder = Object.assign(new PurchaseOrder(), data)
  },
  CURRENT_ITEMS (state, data) {
    state.purchaseOrder.purchase_order_items = data
  },
  PURCHASE_ORDER_ITEMS (state, data) {
    state.purchaseOrder.purchase_order_items = data
  },
  PDF (state, data) {
    state.pdf = data
  }
}

// actions
export const actions = {
  async addItem ({ commit }, data) {
    await axios.post(laroute.route('create_purchase_order', { companyAbbr: this.getters['auth/company'] }), data)
      .then((response) => {
        commit('PURCHASE_ORDER', response.data.data.purchase_order)
      })
  },

  async fetchPurchaseOrderList ({ commit }, filterData) {
    const { data } = await axios.get(laroute.route('purchase_order_filter', {
      companyAbbr: this.getters['auth/company'],
      ...filterData
    }))

    commit('LIST', data.items)
    commit('TOTAL', data.total)
  },
  async fetchOne ({ commit }, id) {
    const { data } = await axios.get(laroute.route('get_purchase_order', {
      'companyAbbr': this.getters['auth/company'],
      'purchaseOrderId': id
    }))
    commit('PURCHASE_ORDER', data.purchase_order)
  },
  async fetchPurchaseOrder ({ commit }, id) {
    const { data } = await axios.get(laroute.route('get_purchase_order', {
      'companyAbbr': this.getters['auth/company'],
      'purchaseOrderId': id
    }))
    commit('PURCHASE_ORDER', data.purchase_order)
  },
  async update ({ commit }, { id, po }) {
    await axios.patch(laroute.route('update_purchase_order', {
      companyAbbr: this.getters['auth/company'], id
    }), { po })
  },

  async deletePO ({ commit }, { id, reason }) {
    await axios.patch(laroute.route('delete_purchase_order', {
      companyAbbr: store.getters['auth/company'], id
    }), { reason })
  },

  async deletePOItem ({ commit }, { id }) {
    await axios.delete(laroute.route('delete_po_item', {
      id: id
    }))
  },

  async localPOUpdate ({ commit }, po) {
    commit('PURCHASE_ORDER', Object.assign({}, po))
  },

  async approvePO ({ commit }, { id }) {
    await axios.patch(laroute.route('approve_purchase_order', {
      id
    }))
  },

  async generatePDF ({ commit }, id) {
    const { data } = await axios.get(laroute.route('purchase-order-generate-pdf', { companyAbbr: store.getters['auth/company'], id }), { responseType: 'arraybuffer' })

    commit('PDF', data)
  },

  async getActivePO ({ commit }) {
    const { data } = await axios.get(laroute.route('get-active-po', { companyAbbr: store.getters['auth/company'] }))

    commit('LIST', data)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/purchaseOrder.js